import { Dimensions } from 'react-native';

const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;
const mobile = 640;
const desktop = 1440;
const tablet = 720;

const isSmall = width <= mobile;
const isMedium = width > mobile && width < desktop;
const isLarge = width >= desktop;
const isCompactScreen = width < tablet;

export default {
  window: {
    width,
    height,
  },
  isSmall,
  isMedium,
  isLarge,
  isCompactScreen,
  mobile,
  usePantryTabs: width < 900, // do we use separate map/list tabs in the pantries view?
  signupContainer: {
    flex: 1,
    justifyContent: isSmall ? 'space-between' : 'flex-start',
    alignItems: 'center',
  },
  signupFooter: {
    marginTop: height > 850 ? 204 : 0,
    width: 328,
    alignItems: 'center',
    height: isSmall ? 148 : 300,
  },
  topMenuHeight: 65,
  fullWidth: width,
  fullHeight: height,
};
